'use client';
import Link from 'next/link';
import { HugeiconsIcon } from '@hugeicons/react';
import {
  DashboardSquare01Icon,
  FavouriteIcon,
  GiftIcon,
  Logout01Icon,
  ProductLoadingIcon,
  UserAccountIcon,
} from '@hugeicons/core-free-icons';
import { useAuth } from '../authentication/hooks/auth';
import { useRouter } from 'next/navigation';

const dashboardSidebarItem = [
  {
    name: 'My Orders',
    slug: 'my-orders',
  },
  {
    name: 'Account Details',
    slug: 'account-details',
  },
  {
    name: 'My WishList',
    slug: 'my-wishlist',
  },
  {
    name: 'My Rewards',
    slug: 'my-rewards',
  },
];

// ✅ Icon resolver
const getSidebarIcon = (slug: string) => {
  switch (slug) {
    case 'my-orders':
      return ProductLoadingIcon;
    case 'account-details':
      return UserAccountIcon;
    case 'my-wishlist':
      return FavouriteIcon;
    case 'my-rewards':
      return GiftIcon;
    default:
      return DashboardSquare01Icon; // Fallback
  }
};

const DashboardSidebar = ({
  activeCard,
  onNavigate,
}: {
  activeCard?: string | null;
  onNavigate?: (slug: string | null) => void;
}) => {
  const router = useRouter();
  const { logout } = useAuth();

  return (
    <div className="dashboard__sidebarmenu ">
      <ul className="dashboard__menu nav d-flex">
        <li className="nav-item">
          <a
            onClick={() => onNavigate?.(null)}
            className={`nav-link dashboard__menu-item ${
              activeCard === null ? 'active' : ''
            }`}
            href="#"
          >
            <HugeiconsIcon icon={DashboardSquare01Icon} size={20} /> Dashboard
          </a>
        </li>

        {dashboardSidebarItem.map((item) => (
          <li key={item.slug} className="nav-item">
            <a
              href="#"
              onClick={() => {
                if (item.slug === 'my-wishlist') {
                  router.push('/wishlist');
                } else {
                  onNavigate?.(item.slug);
                }
              }}
              className={`nav-link dashboard__menu-item ${
                activeCard === item.name ? 'active' : ''
              }`}
            >
              <HugeiconsIcon icon={getSidebarIcon(item.slug)} size={20} />{' '}
              {item.name}
            </a>
          </li>
        ))}
      </ul>

      <div className="dashboard__logout mt-4 d-none d-md-block">
        <ul className="dashboard__menu nav">
          <li
            style={{ cursor: 'pointer' }}
            onClick={() => logout()}
            className="nav-item"
          >
            <p className="nav-link dashboard__menu-item">
              <HugeiconsIcon icon={Logout01Icon} size={20} /> Logout
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DashboardSidebar;
